import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../Library/BaseComponent';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { MasterDataService } from '../../Services/MasterDataService';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';
import { AnalyticsService } from '../../Services/AnalyticsService';

@Component({
  selector: 'app-analytics',
  templateUrl: './analytics.component.html'
})
export class AnalyticsComponent extends BaseComponent implements OnInit {

  constructor(
    public translate: TranslateService, 
    public toastr: ToastrService, 
    public route: ActivatedRoute, 
    public router: Router, 
    public masterService: MasterDataService, 
    public modalService: NgbModal,
    public analyticsService: AnalyticsService,
    public sanitizer: DomSanitizer
  ) {
      super(translate, toastr, route, router, masterService);
      route.params.subscribe(val => {
          this.module = (this.route.data['value'].SelectedModule == 9) ? 'service' : ((this.route.data['value'].SelectedModule == 11) ? 'hk' : 'glitch');
          console.log(val, this.route.data['value'].SelectedModule, " ====== this.route.data['value'].SelectedModule")
          this.fetchAnalyticsURL(this.module);
      });
}
  public module = 'service';
  public analyticsUrl: any;
  ngOnInit():void {}


    async fetchAnalyticsURL(module: string) {
        let iframeURL = await this.analyticsService.fetchAnalyticsURL(module);
        console.log(iframeURL, "=> iframeURL");
        this.analyticsUrl = this.sanitizer.bypassSecurityTrustResourceUrl(iframeURL ? iframeURL : "");
  }

}
